<template>
  <BaseModal v-model:open="isOpen">
    <ClientOnly>
      <div class="relative">
        <VueFlux
          ref="$vueFlux"
          :options="config"
          :rscs="rscs"
          :transitions="transitions"
        >
          <template #preloader="preloaderProps">
            <FluxPreloader v-bind="preloaderProps" />
          </template>

          <template #controls="controlsProps">
            <FluxControls v-bind="controlsProps" />
          </template>

          <template #pagination="paginationProps">
            <FluxPagination v-bind="paginationProps" />
          </template>
        </VueFlux>
      </div>
    </ClientOnly>
  </BaseModal>
</template>

<script setup lang="ts">
import { defineModel, ref, shallowReactive, computed } from 'vue';
import BaseModal from '~/components/modals/BaseModal.vue';
import {
  VueFlux,
  FluxControls,
  FluxPagination,
  FluxPreloader,
  Img,
  Swipe,
  type VueFluxOptions,
} from 'vue-flux';
import 'vue-flux/style.css';

interface Props {
  open: boolean
  slides: string[]
}

const props = defineProps<Props>();

const config: VueFluxOptions = shallowReactive({
  autoplay: false,
  enableGestures: true,
  allowFullscreen: true,
  bindKeys: true,
});
const isOpen = defineModel<Props['open']>('open', { default: false });
const $vueFlux = ref();
const rscs = computed(() => props.slides.map(slide => (new Img(slide))));
const transitions = shallowReactive([
  {
    component: Swipe,
    options: shallowReactive({
      totalDuration: 300,
      easing: 'ease-in-out',
    }),
  },
]);
</script>

<style>
.flux-pagination {
  .pagination-item {
    @apply !bg-brand-secondary;
    &.active {
      @apply !border-brand-black !bg-brand-primary;
    }
  }
}
</style>
